import styled from '@emotion/styled';
import React, { useRef } from 'react';
import { useButton, useHover } from 'react-aria';

import glyphStyles from '../../components/common/Glyph.module.css';
import { su } from '../../theme/functions/su';
import { glyph } from '../../theme/glyph';
import { motion } from '../../theme/motion';
import { theme } from '../../theme/theme';

import { Circle } from '../../components/common/Circle';
import { Glyph } from '../../components/common/Glyph';

export function LegendItem(props) {
  const buttonRef = useRef();
  const button = useButton(
    {
      onPress: () => {
        props.onRemoveIdRequest({
          logId: props.logId,
        });
      },
    },
    buttonRef,
  );

  const hover = useHover({
    onHoverStart: props.onHoverStart,
    onHoverEnd: props.onHoverEnd,
  });

  return (
    <LegendItem.Root {...hover.hoverProps} style={{ '--hue': props.color?.hue ?? 0 }}>
      <LegendItem.Button {...button.buttonProps} ref={buttonRef}>
        <Glyph
          source={glyph.core.crossCircle}
          size={theme.icon.size_medium}
          color={theme.icon.color_light}
        />
      </LegendItem.Button>

      <LegendItem.Owner.Root>
        <LegendItem.Owner.Name>{props.ownerName}</LegendItem.Owner.Name>
        <LegendItem.Owner.ZoneName>{props.ownerZoneName}</LegendItem.Owner.ZoneName>
      </LegendItem.Owner.Root>

      <LegendItem.Log.Root>
        <LegendItem.Log.Circle hue={props.color?.hue ?? 0} />
        <LegendItem.Log.Name>{props.log.title}</LegendItem.Log.Name>
      </LegendItem.Log.Root>
    </LegendItem.Root>
  );
}

LegendItem.Button = styled.button`
  position: absolute;
  right: -8px;
  top: -8px;
  opacity: 0;
  transition: ${motion.transition.micro};

  .${glyphStyles.root} {
    transition: ${motion.transition.micro};

    &:hover {
      color: ${theme.color.danger};
      transform: scale(${theme.icon.scale_default});
    }
  }
`;

LegendItem.Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${su(1)} ${su(2)};
  border: 1px solid transparent;
  border-radius: ${theme.borderRadius.default};
  cursor: default;
  transition: ${motion.transition.micro};

  &:hover {
    background-color: ${theme.color.mono_010};
    border-color: ${theme.color.line};

    ${LegendItem.Button} {
      opacity: 1;
    }
  }
`;

LegendItem.Owner = {};
LegendItem.Owner.Name = styled.div``;
LegendItem.Owner.ZoneName = styled.div``;
LegendItem.Owner.Root = styled.div`
  display: flex;
  align-items: center;

  ${LegendItem.Owner.Name} {
    font-weight: ${theme.fontWeight.medium};
    margin-inline-end: 5px;
  }

  ${LegendItem.Owner.ZoneName} {
    color: ${theme.color.text_light};
  }
`;

LegendItem.Log = {};
LegendItem.Log.Circle = styled(Circle)``;
LegendItem.Log.Name = styled.div``;
LegendItem.Log.Root = styled.div`
  display: flex;
  align-items: center;

  ${LegendItem.Log.Circle} {
    margin-inline-end: 5px;
  }

  ${LegendItem.Log.Name} {
    margin-inline-start: 5px;
  }
`;
